import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import ContentDrawer from '../ContentDrawer';
import FormActions from '../Form/FormActions';
import Spreadsheet from '../Spreadsheet';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import translations from './translations';

const BulkDrawer = ({
  columns,
  disableSubmitOnEmpty,
  isLoading,
  isOpen,
  onSubmit,
  onClose,
  title,
}) => {
  const intl = useIntl();
  const [data, setData] = useState([]);

  const handleOnSubmit = () => {
    if (onSubmit && typeof onSubmit === 'function') {
      onSubmit(data);
    }
  };

  return (
    <ContentDrawer title={title} isOpen={isOpen} handleClose={onClose} drawerWidth="600px">
      <LoadingWrapper isLoading={isLoading}>
        <Spreadsheet
          onChange={changedData => setData(changedData)}
          columns={columns}
          height={500}
          startRows={25}
        />
      </LoadingWrapper>
      <FormActions
        primaryAction={{
          label: intl.formatMessage(translations.formActions.save),
          onClick: handleOnSubmit,
          type: 'submit',
          color: 'primary',
          variant: 'contained',
          disabled: isLoading || (disableSubmitOnEmpty && data?.length === 0),
        }}
        secondaryAction={{
          label: intl.formatMessage(translations.formActions.cancel),
          onClick: onClose,
          disabled: isLoading,
        }}
      />
    </ContentDrawer>
  );
};

BulkDrawer.propTypes = {
  columns: PropTypes.array,
  disableSubmitOnEmpty: PropTypes.bool,
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  title: PropTypes.string,
};

BulkDrawer.defaultProps = {
  columns: [],
  disableSubmitOnEmpty: true,
  isLoading: false,
  isOpen: false,
  onSubmit: undefined,
  onClose: undefined,
  title: undefined,
};

export default BulkDrawer;
